import multilineFileProcess from "sagas/formFields/multilineFileProcess";

export default [...multilineFileProcess];
